let baseUrl;
let codeUrl;
if (process.env.NODE_ENV === "production") {
  baseUrl = "/gateway"; //生产环境
  codeUrl = "https://la-platform-sta.dtinsure.com/gateway";
} else {
  baseUrl = "/la-api"; //开发环境
  codeUrl = "https://la-platform-sta.dtinsure.com/gateway";
}

// const mock = "/mock"; //暂时测试

export const rootPath = baseUrl;

export const codePath = codeUrl;
export const publicKey =
  "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA4mpxshprdB8GPydiSG9w +bp7sJKYTkKNrYlt9Tdjde6hsDwC/cpyr/6Bd6qYampjOyP9iz/slJzXzWgxEeE1 NsZvdREvdgB3lkIHK82CF2VLJse180ztmsUnQzHWl2GM8M8U87DPomA89bB433Kb 5Sf5SpuSfCAqz8y9AO2RdYPYAJKjubhOsqo4dn2Kv6P4bYjLKOaUcRUPrbZwvY1G udoxXJmA1/xtd1ZeIiwAuD4+2CFCEs/P6u1UOWd4cd/J4+icXyXgYyV4Y9oaYsVG g6xZTrQY8VXPS61qodKt3qyQc16C75L2/niSPnCPAQUkUhCRTn7xFDPP4y+qJW7B EQIDAQAB";
